<template>
  <portlet
      :icon=" ''"
      :title="$t('menu.improvements')"
      :actions-block="false"
      :fullheight="false"
      class="portlet-pt-10"
  >
    <template slot="portletBody">
      <div class=" ">

        <div class="row">
          <div class="col" :key="idx+1" v-for="(status,idx) in statusses "
               :class="getImprovementsByStatus[status.value] ? 'has-count':'has-no-count' ">
            <span class="badge badge-primary w-100 "
                  :style="{background:getIcon(status.value).textColor}">  {{
                getImprovementsByStatus[status.value] ? getImprovementsByStatus[status.value].length : 0
              }}
            {{ getIcon(status.value).text }}</span>
          </div>

        </div>

        <div class="row mt-5">
          <div class="col-12">

            <table class="table table-striped">

              <thead>
              <th>{{ $t('improvements.table.status') }}</th>
              <th>{{ $t("workflowInterface.suggestions.modal.title")}}</th>
              <th>{{ $t('improvements.table.updated') }}</th>
              <th>{{ $t('improvements.table.created') }}</th>
              <th></th>
              </thead>
              <tbody>
              <tr :key="idx+1" v-for="(improvement ,idx) in getLastTenImprovements">
                <td  data-label="Status">  {{ $t('improvements.improvement.statusses.'+improvement.status) }}</td>
                <td  data-label="Title">{{ getTitle(improvement.title) }}</td>
                <td  data-label="Last updated">{{ updatedAt(improvement.updated_at) }}</td>
                <td  data-label="Created">{{ createdAt(improvement.created_at) }}</td>
                <td  data-label="" mobileAlignment="center"><router-link :to="{path:'/improvements?improvementId=' +improvement.id}"> <i title="View" class="far fa-eye"></i></router-link></td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </template>
  </portlet>
</template>

<script>
import {mapGetters} from 'vuex'
import icons from "@/mixins/improvements/icons";


export default {
  name: "ImprovementStatusPortlet",
  mixins: [icons],
  data() {
    return {
      statusses: [
        {value: 'pending', visible: false, rights: 'admin'},
        {value: 'denied', visible: false, rights: 'admin'},
        {value: 'plan', visible: true, rights: 'user'},
        {value: 'do', visible: true, rights: 'user'},
        {value: 'check', visible: true, rights: 'user'},
        {value: 'act', visible: true, rights: 'user'},
        // {value: 'done', visible: true, rights: 'user'},
      ],
    }
  },
  computed: {
    ...mapGetters('users', [
      'getMe',
      'getClaims',
    ]),
    ...mapGetters('improvements', [
      'getImprovements',
      'getImprovementsByStatus'
    ]),
    getLastTenImprovements() {
      let improvements = _.filter(this.getImprovements, improvement => {
        return improvement.status !== undefined && improvement.status != 'done'
      })
      improvements.map(improvement => {
        // improvement.updated_at = moment(improvement.updated_at).format('DD-MM-YY HH:mm:ss')
        // improvement.created_at = moment(improvement.created_at).format('DD-MM-YY ')
        improvement.title = _.truncate(improvement.title, 50)
        if(!improvement.updated_at){
          improvement.updated_at = improvement.created_at
        }
      })
      improvements = _.orderBy(improvements, ['updated_at', 'created_at'], ['desc', 'desc'])

      return _.take(improvements, 10)
    },

  },
  methods: {
    getBadge(improvement){
      let icon = this.getIcon(improvement)
      return `<span  class="badge badge-primary  w-100" style="background:${icon.textColor}">${icon.text}</span>`
    },
    getTitle(title) {
      return _.truncate(title, 30)
    },
    updatedAt(date) {
      if(date){
      return moment(date).format('DD-MM-YY HH:mm:ss')
      }else{
        return ''
      }
    },
    createdAt(date) {
      return moment(date).format('DD-MM-YY')

    }
  },
  async beforeRouteLeave(to, from, next) {
    await this.$store.dispatch('improvements/closeDBChannel');
    next();
  },
  created() {
    let where = [
      ['companyId', '==', this.getClaims.companyId],

    ];

    this.$store.dispatch('improvements/openDBChannel', {where});
  }
}
</script>

<style scoped lang="scss">

@import "src/assets/scss/mobile/mobilizeTables.scss";

.has-no-count {
  opacity: 0.2 !important;
}
</style>